export const MUConstants = {
    dateFromatDelimiterToAPI: "-",
    defualtYearToAPI: "1918",
    defualtMonthToAPI: "01",
    noDateToAPI: "0",
    noMonthTOAPI: "0",
    noYearToAPI: "0"
}

export const MedicalCondQuestionSet = {
    lifestyle: "Lifestyle",
    adl: "DailyLiving"
}

export const MedicalDashboardStatus = {
    completed: "Complete",
    notCompleted: "Incomplete"
}

export const MedClassificationPattern = {
    partOne : 'subcondition_classification="',
    partTwo : '"',

}